import { get } from '../../infra/rest';
import requestConfig from '../config/request';
import { CallRestrictionsResponse } from '../typings/meta-call-restrictions';

export const getCallRestrictions = async (): Promise<CallRestrictionsResponse> => {
  return await get<CallRestrictionsResponse>(
    `${requestConfig.aiBotBaseUrl}/v1/call/calling-restrictions`,
    {},
    true,
    false,
    true
  );
};
